import {
  LineChart,
  LayoutDashboard,
  ScanFace,
  History,
  Trophy,
  Wallet,
  Coins,
  MessagesSquare,
  UserCog,
  type LucideIcon,
} from "lucide-react";

export interface TraderNavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** Optional badge text shown on the right (e.g. status count). */
  badge?: string;
}

/**
 * Trader sidebar — PROP-FIRM (AXProp).
 * No deposits/withdrawals to a personal balance, no IB/copy/PAMM. The trader
 * buys evaluation challenges, trades funded accounts, and requests payouts.
 * Unwired routes fall through to a stub page until the feature ships.
 */
export const traderNav: TraderNavItem[] = [
  { label: "Dashboard", to: "/trader/dashboard", icon: LayoutDashboard },
  { label: "Buy Challenge", to: "/trader/challenges", icon: Trophy },
  { label: "My Accounts", to: "/trader/accounts", icon: Wallet },
  { label: "Web Trader", to: "/trader/web-trader", icon: LineChart },
  { label: "Trade History", to: "/trader/history", icon: History },
  { label: "Payouts", to: "/trader/payouts", icon: Coins },
  { label: "KYC Verification", to: "/trader/kyc", icon: ScanFace },
  { label: "My Profile", to: "/trader/profile", icon: UserCog },
  { label: "Support Tickets", to: "/trader/support", icon: MessagesSquare },
];
